import {
  collection,
  doc,
  getDocs,
  setDoc,
  deleteDoc,
  updateDoc,
} from 'firebase/firestore';
import {firestore} from './firebase';
import {SavedQuestion} from '../models';
import {FirestoreCollection, Question} from 'hubbl-shared';

// Hardcoded for now - will be added to hubbl-shared later

const getQuestionBank = async (companyId: string): Promise<SavedQuestion[]> => {
  const companyRef = doc(firestore, FirestoreCollection.Companies, companyId);
  const questionBankRef = collection(
    companyRef,
    FirestoreCollection.QuestionBank,
  );

  const querySnapshot = await getDocs(questionBankRef);

  const questions: SavedQuestion[] = querySnapshot.docs.map(docSnapshot => {
    const data = docSnapshot.data() as SavedQuestion;
    return {
      ...data,
      id: docSnapshot.id,
    };
  });

  return questions;
};

const saveQuestionToBank = async (
  companyId: string,
  question: Question,
  createdBy: {id: string; fullName: string},
  isEvaluation?: boolean,
): Promise<SavedQuestion> => {
  const companyRef = doc(firestore, FirestoreCollection.Companies, companyId);
  const questionId = `saved-${Date.now()}`;
  const questionRef = doc(
    companyRef,
    FirestoreCollection.QuestionBank,
    questionId,
  );

  const savedQuestion: SavedQuestion = {
    ...question,
    id: questionId,
    createdAt: new Date().toISOString(),
    createdBy,
    isEvaluation: isEvaluation ?? false,
  };

  await setDoc(questionRef, savedQuestion);

  return savedQuestion;
};

const updateQuestionInBank = async (
  companyId: string,
  question: SavedQuestion,
): Promise<void> => {
  const companyRef = doc(firestore, FirestoreCollection.Companies, companyId);
  const questionRef = doc(
    companyRef,
    FirestoreCollection.QuestionBank,
    question.id,
  );

  await updateDoc(questionRef, {
    questionText: question.questionText,
    type: question.type,
    options: question.options,
    isRequired: question.isRequired,
    allowFreeText: question.allowFreeText,
    isEvaluation: question.isEvaluation ?? false,
  });
};

const deleteQuestionFromBank = async (
  companyId: string,
  questionId: string,
): Promise<void> => {
  const companyRef = doc(firestore, FirestoreCollection.Companies, companyId);
  const questionRef = doc(
    companyRef,
    FirestoreCollection.QuestionBank,
    questionId,
  );

  await deleteDoc(questionRef);
};

export const questionBank = {
  getQuestionBank,
  saveQuestionToBank,
  updateQuestionInBank,
  deleteQuestionFromBank,
};
